// This icon file is generated automatically.
var Css3Outlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M1.5 0l1.6 18.06L10 20l6.9-1.94L18.5 0h-17zm13.58 5.85L9.99 8.12v.01h4.9l-.55 6.76L10 16.21l-4.36-1.34-.28-3.4h2.15l.15 1.76 2.31.6H10l2.4-.7.17-2.84-2.57-.01-4.78-.02-.16-2.13L10 5.98l.3-.13H4.85l-.25-2.18h10.68l-.21 2.18z", "fill-rule": "evenodd" } }] }, "name": "css3", "theme": "outlined" };
export default Css3Outlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/Css3Outlined.js
// module id = 2359
// module chunks = 0